var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 151.719,
    height: 130.912,
    viewBox: "0 0 151.719 130.912",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "medal",
    transform: "translate(0 -35.105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14308",
    "data-name": "Path 14308",
    d: "M191.223,121.635a1.62,1.62,0,0,0-1.368-.754H139.97a1.619,1.619,0,0,0-1.368.754l-11.8,18.636a1.62,1.62,0,0,0,.094,1.866l36.738,46.831a1.62,1.62,0,0,0,2.549,0l36.738-46.831a1.62,1.62,0,0,0,.094-1.866Z",
    transform: "translate(-89.054 -60.359)",
    fill: "#4baed2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14309",
    "data-name": "Path 14309",
    d: "M138.6,121.635l-.2.319-11.595,18.318a1.618,1.618,0,0,0-.247.966h76.707a1.614,1.614,0,0,0-.247-.966l-11.595-18.318-.2-.319a1.62,1.62,0,0,0-1.368-.754H139.973A1.62,1.62,0,0,0,138.6,121.635Z",
    transform: "translate(-89.057 -60.359)",
    fill: "#4baed2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2654",
    "data-name": "Group 2654",
    transform: "translate(62.792 60.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14310",
    "data-name": "Path 14310",
    d: "M224.871,120.881,211.9,141.236h25.933Z",
    transform: "translate(-211.905 -120.881)",
    fill: "#94e7ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14311",
    "data-name": "Path 14311",
    d: "M299.422,141.7h25.486a1.63,1.63,0,0,0-.044-.489s0-.006,0-.009a1.624,1.624,0,0,0-.071-.212c0-.009-.006-.02-.01-.029a1.626,1.626,0,0,0-.12-.228l-2.39-3.775-7.683-12.138-1.724-2.724a1.6,1.6,0,0,0-.123-.169l-.016-.017a1.56,1.56,0,0,0-.127-.134l0,0a1.63,1.63,0,0,0-.331-.236h0Z",
    transform: "translate(-273.489 -121.343)",
    fill: "#94e7ef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14312",
    "data-name": "Path 14312",
    d: "M340.76,141.7h0a1.629,1.629,0,0,0-.044-.489h0V141.2a1.62,1.62,0,0,0-.071-.212c0-.009-.006-.02-.01-.029a1.626,1.626,0,0,0-.12-.228l-2.158-3.409-2.637-4.167-5.277-8.337-1.724-2.723a1.6,1.6,0,0,0-.123-.169l-.013-.014,0,0a1.6,1.6,0,0,0-.127-.134h0l0,0a1.624,1.624,0,0,0-.33-.236h0l-6.168,9.682,5.7,9a1.618,1.618,0,0,1,.128,1.477Z",
    transform: "translate(-226.548 -60.82)",
    fill: "#4baed2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14313",
    "data-name": "Path 14313",
    d: "M139.205,121.538a1.615,1.615,0,0,0-.6.559l-4.143,6.546-7.653,12.091a1.618,1.618,0,0,0-.247.966h25.486Z",
    transform: "translate(-89.057 -60.821)",
    fill: "#94e7ef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2655",
    "data-name": "Group 2655",
    transform: "translate(37.505 80.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14314",
    "data-name": "Path 14314",
    d: "M152.055,189.573H126.569a1.617,1.617,0,0,0,.341.9L163.648,237.3a1.6,1.6,0,0,0,1.006.6Z",
    transform: "translate(-126.569 -189.573)",
    fill: "#1990c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14315",
    "data-name": "Path 14315",
    d: "M294.645,190.473a1.64,1.64,0,0,0,.139-.208,1.591,1.591,0,0,0,.089-.193c0-.01.009-.019.013-.029a1.628,1.628,0,0,0,.1-.468v0H269.4L256.9,237.9h0a1.622,1.622,0,0,0,.513-.178l.044-.024c.026-.015.052-.033.077-.05l.068-.048.062-.049q.041-.034.08-.072c.015-.015.031-.028.045-.043a1.638,1.638,0,0,0,.117-.133l23.288-29.685Z",
    transform: "translate(-218.279 -189.572)",
    fill: "#1990c9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2656",
    "data-name": "Group 2656",
    transform: "translate(76.124 60.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14316",
    "data-name": "Path 14316",
    d: "M294.644,190.475a1.64,1.64,0,0,0,.139-.208,1.6,1.6,0,0,0,.088-.191l0-.009c0-.007.007-.015.01-.022a1.631,1.631,0,0,0,.1-.468v0H282a1.613,1.613,0,0,1-.222.389L263.159,213.7,256.9,237.9h0a1.622,1.622,0,0,0,.513-.177l.031-.017.013-.007c.026-.015.052-.033.077-.049s.046-.031.069-.048l.062-.049.03-.027.05-.045c.015-.014.031-.028.045-.043a1.581,1.581,0,0,0,.117-.133l23.288-29.685Z",
    transform: "translate(-256.898 -169.219)",
    fill: "#006397"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14317",
    "data-name": "Path 14317",
    d: "M307.012,130.758l6.165-9.678a1.527,1.527,0,0,0-.765-.2h-11.69a1.622,1.622,0,0,1,.192.242Z",
    transform: "translate(-287.736 -120.881)",
    fill: "#006397"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2657",
    "data-name": "Group 2657",
    transform: "translate(69.224 104.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14318",
    "data-name": "Path 14318",
    d: "M251.893,350.856a1.6,1.6,0,0,1-.191-.2A1.6,1.6,0,0,0,251.893,350.856Z",
    transform: "translate(-246.342 -327.045)",
    fill: "#1990c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14319",
    "data-name": "Path 14319",
    d: "M252.719,351.624a1.631,1.631,0,0,1-.153-.109A1.577,1.577,0,0,0,252.719,351.624Z",
    transform: "translate(-246.95 -327.65)",
    fill: "#1990c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14320",
    "data-name": "Path 14320",
    d: "M253.524,352.127a1.545,1.545,0,0,1-.173-.08A1.47,1.47,0,0,0,253.524,352.127Z",
    transform: "translate(-247.502 -328.024)",
    fill: "#1990c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14321",
    "data-name": "Path 14321",
    d: "M254.68,352.554l-.057-.015Z",
    transform: "translate(-248.397 -328.371)",
    fill: "#1990c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14322",
    "data-name": "Path 14322",
    d: "M233.612,327.6l.233.3Z",
    transform: "translate(-233.612 -310.818)",
    fill: "#1990c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14323",
    "data-name": "Path 14323",
    d: "M244.832,283.517l3.039,11.656a1.664,1.664,0,0,0,.539,0l6.259-24.2Z",
    transform: "translate(-241.507 -270.978)",
    fill: "#1990c9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2658",
    "data-name": "Group 2658",
    transform: "translate(69.458 122.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14324",
    "data-name": "Path 14324",
    d: "M254.9,352.61l0-.009c-.027,0-.054-.007-.08-.012C254.844,352.6,254.871,352.606,254.9,352.61Z",
    transform: "translate(-248.766 -345.48)",
    fill: "#21d8de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14325",
    "data-name": "Path 14325",
    d: "M254.138,352.383a1.573,1.573,0,0,1-.2-.066A1.558,1.558,0,0,0,254.138,352.383Z",
    transform: "translate(-248.145 -345.289)",
    fill: "#21d8de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14326",
    "data-name": "Path 14326",
    d: "M234.4,328.6l5.127,6.535h0Z",
    transform: "translate(-234.399 -328.599)",
    fill: "#21d8de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14327",
    "data-name": "Path 14327",
    d: "M252.412,351.387c-.022-.017-.044-.035-.065-.054C252.368,351.352,252.39,351.369,252.412,351.387Z",
    transform: "translate(-247.029 -344.596)",
    fill: "#21d8de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14328",
    "data-name": "Path 14328",
    d: "M253.162,351.932c-.027-.015-.053-.032-.079-.049C253.109,351.9,253.135,351.917,253.162,351.932Z",
    transform: "translate(-247.547 -344.983)",
    fill: "#21d8de"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14329",
    "data-name": "Path 14329",
    d: "M233.612,317.532l.233.3,5.126,6.535h0a1.6,1.6,0,0,0,.191.2c.021.019.043.036.065.054a1.558,1.558,0,0,0,.153.109c.026.017.052.034.079.049a1.653,1.653,0,0,0,.173.08,1.617,1.617,0,0,0,.2.066l.057.015c.027.006.054.008.08.012l-3.039-11.656Z",
    transform: "translate(-164.388 -195.755)",
    fill: "#4baed2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2659",
    "data-name": "Group 2659",
    transform: "translate(0 45.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14330",
    "data-name": "Path 14330",
    d: "M38.307,83.029A103.633,103.633,0,0,1,50.562,71.607a.69.69,0,0,1,1.093.719c-2.475,9.1-6.8,18.089-13.467,24.773A91.447,91.447,0,0,1,38.307,83.029Z",
    transform: "translate(-26.722 -71.456)",
    fill: "#2dcc7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14331",
    "data-name": "Path 14331",
    d: "M11.466,122.433A103.607,103.607,0,0,1,1.328,107.8a.687.687,0,0,0-1.282.3c-.538,10.621,3.521,23.049,13.407,28.061A91.822,91.822,0,0,1,11.466,122.433Z",
    transform: "translate(0 -96.787)",
    fill: "#2dcc7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14332",
    "data-name": "Path 14332",
    d: "M45.4,170.112a99.654,99.654,0,0,1,8.312-14.117.689.689,0,0,1,1.25.364c.387,9.175-1.187,18.873-5.583,26.927A92.49,92.49,0,0,1,45.4,170.112Z",
    transform: "translate(-31.948 -130.739)",
    fill: "#2dcc7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14333",
    "data-name": "Path 14333",
    d: "M22.99,223.032a107.464,107.464,0,0,1-13.944-10.67.687.687,0,0,0-1.127.678C10.558,223.186,18.1,233.6,28.846,235.435A92.991,92.991,0,0,1,22.99,223.032Z",
    transform: "translate(-5.556 -170.482)",
    fill: "#2dcc7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14334",
    "data-name": "Path 14334",
    d: "M78.59,251.982a98.02,98.02,0,0,1,3.871-15.811.689.689,0,0,1,1.3-.015c3.049,8.608,4.284,18.318,2.444,27.243A92.908,92.908,0,0,1,78.59,251.982Z",
    transform: "translate(-55.302 -187.032)",
    fill: "#2dcc7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14335",
    "data-name": "Path 14335",
    d: "M62.995,314.517a109.6,109.6,0,0,1-16.411-6.107.687.687,0,0,0-.878.978c5.481,8.938,15.743,16.677,26.551,15.344A92.312,92.312,0,0,1,62.995,314.517Z",
    transform: "translate(-32.089 -238.148)",
    fill: "#2dcc7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14336",
    "data-name": "Path 14336",
    d: "M133.192,323.305a95.966,95.966,0,0,1-.955-16.315.689.689,0,0,1,1.24-.394c5.459,7.4,9.532,16.392,10.506,25.507A91.709,91.709,0,0,1,133.192,323.305Z",
    transform: "translate(-93.026 -236.724)",
    fill: "#2dcc7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14337",
    "data-name": "Path 14337",
    d: "M441.146,83.029a103.632,103.632,0,0,0-12.254-11.422.69.69,0,0,0-1.093.719c2.475,9.1,6.8,18.089,13.467,24.773A91.444,91.444,0,0,0,441.146,83.029Z",
    transform: "translate(-301.014 -71.456)",
    fill: "#2dcc7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14338",
    "data-name": "Path 14338",
    d: "M468.584,122.433A103.606,103.606,0,0,0,478.721,107.8a.687.687,0,0,1,1.282.3c.538,10.621-3.521,23.049-13.407,28.061A91.827,91.827,0,0,0,468.584,122.433Z",
    transform: "translate(-328.333 -96.787)",
    fill: "#2dcc7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14339",
    "data-name": "Path 14339",
    d: "M443.756,170.112a99.654,99.654,0,0,0-8.312-14.117.689.689,0,0,0-1.25.364c-.387,9.175,1.187,18.873,5.583,26.927A92.5,92.5,0,0,0,443.756,170.112Z",
    transform: "translate(-305.492 -130.739)",
    fill: "#2dcc7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14340",
    "data-name": "Path 14340",
    d: "M439.26,223.032a107.465,107.465,0,0,0,13.944-10.67.687.687,0,0,1,1.127.678c-2.638,10.145-10.184,20.556-20.926,22.394A92.992,92.992,0,0,0,439.26,223.032Z",
    transform: "translate(-304.976 -170.482)",
    fill: "#2dcc7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14341",
    "data-name": "Path 14341",
    d: "M413.276,251.982a98.02,98.02,0,0,0-3.871-15.811.689.689,0,0,0-1.3-.015c-3.049,8.608-4.284,18.318-2.444,27.243A92.907,92.907,0,0,0,413.276,251.982Z",
    transform: "translate(-284.847 -187.032)",
    fill: "#2dcc7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14342",
    "data-name": "Path 14342",
    d: "M385.708,314.517a109.6,109.6,0,0,0,16.411-6.107.687.687,0,0,1,.878.978c-5.481,8.938-15.743,16.677-26.551,15.344A92.341,92.341,0,0,0,385.708,314.517Z",
    transform: "translate(-264.896 -238.148)",
    fill: "#2dcc7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14343",
    "data-name": "Path 14343",
    d: "M350.829,323.305a95.966,95.966,0,0,0,.955-16.315.689.689,0,0,0-1.24-.394c-5.459,7.4-9.531,16.392-10.506,25.507A91.71,91.71,0,0,0,350.829,323.305Z",
    transform: "translate(-239.277 -236.724)",
    fill: "#2dcc7a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14344",
    "data-name": "Path 14344",
    d: "M163.859,57.636c0-.045,0-.09,0-.135a99.885,99.885,0,0,0-3.816-20.754,2.29,2.29,0,0,0-4.392,1.3,95.309,95.309,0,0,1,3.624,19.6c0,.049,0,.1.006.148a89.353,89.353,0,0,1,.115,13.7.037.037,0,0,0,0,.006,89.768,89.768,0,0,1-1.936,13.363h0a90.519,90.519,0,0,1-3.876,12.827v0h0a91,91,0,0,1-5.7,12.076h0a90.944,90.944,0,0,1-7.418,11.117v0a90.386,90.386,0,0,1-9.017,9.943h0a89.7,89.7,0,0,1-10.506,8.563c-.014.01-.027.022-.041.032s-.028.018-.041.028c-6.595,5.067-9.937,6.331-13.475,7.668a43.389,43.389,0,0,0-9.992,5.029,43.39,43.39,0,0,0-9.992-5.029c-3.538-1.338-6.88-2.6-13.475-7.668-.013-.01-.027-.018-.041-.028s-.027-.022-.041-.032a89.669,89.669,0,0,1-10.506-8.563h0a90.36,90.36,0,0,1-9.017-9.943v0a90.911,90.911,0,0,1-7.418-11.117h0a90.961,90.961,0,0,1-5.7-12.076h0v0a90.483,90.483,0,0,1-3.876-12.827h0a89.735,89.735,0,0,1-1.936-13.363.041.041,0,0,1,0-.006,89.355,89.355,0,0,1,.115-13.7c0-.05,0-.1.006-.148a95.312,95.312,0,0,1,3.624-19.6,2.29,2.29,0,0,0-4.392-1.3A99.884,99.884,0,0,0,30.908,57.5c0,.045,0,.09,0,.135a94.248,94.248,0,0,0-.1,14.143v0a94.407,94.407,0,0,0,2.03,14.037v.01A95.13,95.13,0,0,0,36.9,99.309v0A95.6,95.6,0,0,0,42.891,112v0a95.471,95.471,0,0,0,7.792,11.682h0a94.94,94.94,0,0,0,9.476,10.454l0,0a94.241,94.241,0,0,0,11,8.973c7.106,5.456,10.92,6.9,14.607,8.292a39.709,39.709,0,0,1,7.622,3.616c-2.368,1.815-5.11,4.092-8.363,7a2.29,2.29,0,1,0,3.053,3.412c3.773-3.376,6.788-5.843,9.3-7.7,2.511,1.856,5.526,4.323,9.3,7.7a2.29,2.29,0,1,0,3.053-3.412c-3.253-2.911-6-5.188-8.363-7a39.7,39.7,0,0,1,7.622-3.616c3.687-1.394,7.5-2.836,14.607-8.292a94.238,94.238,0,0,0,11-8.973l0,0a94.943,94.943,0,0,0,9.476-10.454h0A95.468,95.468,0,0,0,151.871,112v0a95.63,95.63,0,0,0,5.986-12.683v0a95.131,95.131,0,0,0,4.07-13.479v-.01a94.368,94.368,0,0,0,2.03-14.037v0A94.211,94.211,0,0,0,163.859,57.636Z",
    transform: "translate(-21.523)",
    fill: "#00a751"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.7f2cf11bda8f87cffd09068f74ad2f0c.svg";
export { ForwardRef as ReactComponent };